import type * as React from 'react'
import { Icon, type IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import styles from './BookingDetailsSection.module.css'

interface BookingDetailsSectionProps {
  children: React.ReactNode
  isSidebar?: boolean
  title?: string
  description?: string
  iconName?: IconGlyph
  className?: string
}

export function BookingDetailsSection({
  title,
  description,
  iconName,
  isSidebar = false,
  children,
  className,
}: BookingDetailsSectionProps) {
  const header = isSidebar
    ? title && (
      <Typography className={styles.sidebarTitle} as="h2" variant="display-h-regular">
        {title}
      </Typography>
    )
    : title && (
      <>
        <div className={styles.titleWrapper}>
          {iconName && <Icon glyph={iconName} size={24} className={styles.icon} />}
          <Typography className={styles.title} as="h2" variant="display-h-regular">
            {title}
          </Typography>
        </div>
        {description && (
          <Typography as="p" variant="body-m-regular-snug" className={styles.description}>
            {description}
          </Typography>
        )}
      </>
    )

  return (
    <section
      className={cn(isSidebar ? styles.sidebarWrapper : styles.wrapper, className)}
    >
      {header}
      {children}
    </section>
  )
}
